import React, { ReactNode, useState } from "react";

import { Box } from "styles/globalComponents";

import { STATUS } from "Constants/Combos";

import { formatBRLCurrency } from "Utils/FormatCurrency";

import { Button } from "Components/Button";
import { Loader } from "Components/Loader";

import { CATEGORIES } from "Constants/Categories";
import { Product } from "Hooks/useProducts/interface";
import { Container } from "./styles";

export interface PartnerProps {
  list: string;
  price: number;
  id: number;
}
export interface ProductAddionalProps extends Product {
  allPartners?: PartnerProps[];
  cheaperPrice?: number;
}

export interface ProductCardProps {
  product: ProductAddionalProps;
  addToCart: () => Promise<void>;
  removeToCart: () => Promise<void>;
  children?: ReactNode;
  isProductAlredyInCart: boolean;
  blockUserInteraction: boolean;
}

export const CardProduct = ({
  product,
  addToCart,
  removeToCart,
  children,
  isProductAlredyInCart,
  blockUserInteraction,
}: ProductCardProps) => {
  const [loadingTask, setLoadingTask] = useState(false);

  const { default_partner, product_description, is_covered } = product ?? {};

  const { synonym } = product_description ?? {};

  const { category, status } = product;

  const taskRunning = async () => {
    if (category.id === CATEGORIES.vaccine) return;

    setLoadingTask(true);

    if (isProductAlredyInCart) {
      await removeToCart();
    }

    if (!isProductAlredyInCart) {
      await addToCart();
    }

    setLoadingTask(false);
  };

  const isVaccine = category.category === "Vacinas";
  const unavaliable = status.id === Number(STATUS.unavaliable);
  const inactive = status.id === Number(STATUS.inactive);

  const warnMe = unavaliable && isVaccine;

  const buttonContent = () => {
    if (inactive) return "Em espera";
    if (warnMe) return "Avise-me";
    if (unavaliable) return "Indisponível";

    return (
      <Box display="flex" gap="8" className="img-btn" justify="center">
        {isProductAlredyInCart ? "Remover" : "Adicionar"}{" "}
        <div
          className={isProductAlredyInCart ? "cart-bag-remove" : "cart-bag"}
        />
      </Box>
    );
  };

  const coveredPrice = default_partner?.price
    ? `Não Coberto - ${formatBRLCurrency(
        default_partner.price,
        true
      )} em até 12x`
    : "R$ 0,00";

  const isCovenantPrice = is_covered ? "Coberto" : coveredPrice;

  const productPrice = default_partner?.price
    ? formatBRLCurrency(default_partner.price, true)
    : "R$ 0,00";

  const priceItem = Object.hasOwn(product, "is_covered")
    ? isCovenantPrice
    : productPrice;

  return (
    <Container>
      <td>{product.sku}</td>
      <td>{product.product}</td>
      <td>{synonym?.substring(0, 40)}...</td>
      <td className="price">{priceItem}</td>

      <td>
        <Box display="flex" gap="15" justify="center">
          {children}

          <Button
            onClick={taskRunning}
            disabled={loadingTask || blockUserInteraction}
            classButton={`${
              isProductAlredyInCart ? "text-opacity-50" : ""
            } button-cart`}
          >
            {loadingTask ? <Loader size={20} /> : buttonContent()}
          </Button>
        </Box>
      </td>
    </Container>
  );
};
